import { FinalTechMapTable } from './FinalTechMapTable';

export { FinalTechMapTable };
